<section class="flex justify-between items-center mb-3">
    <div>
        <h1 class="text-2xl font-bold text-gray-800">Compañías</h1>
        @if (isSuperAdmin && selectedCompanyId) {
        <p class="text-sm text-slate-500 mt-0.5">
            Empresa seleccionada: ID <strong>{{ selectedCompanyId }}</strong> —
            <button (click)="clearSelection()" class="text-blue-600 hover:underline">deseleccionar</button>
        </p>
        }
    </div>
    <add-button label="Nueva compañía" (onClick)="openEditForm()"></add-button>
</section>

<sau-table #sauTable [url]="url" contentList="list" contentTotal="count" pageParamName="page" contentTotal="total"
    [sizeInitialPage]="1" limitParamName="limit" [sizeBetweenPages]="1" [limit]="10" [headers]="headers" [settings]="settings"
    (deleteEvent)="openDeleteForm($event)" (editEvent)="openEditForm($event)"
    (showEvent)="isSuperAdmin && selectCompany($event)"></sau-table>

@if (isSuperAdmin) {
<p class="mt-3 text-xs text-slate-400">
    Haz clic en el icono <strong>Ver</strong> de una empresa para operar en su contexto.
</p>
}
